import { NeoModel } from "@singularsystems/neo-core";
import { IReport, ReportingServiceBase } from "@singularsystems/neo-reporting";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService"
import InvestorAccrualReport from "../Reports/Accrual/InvestorAccrualReport";
import IssuerAccrualReport from "../Reports/Accrual/IssuerAccrualReport";
import InvestorAccrualScheduleReportReport from "../Reports/AccrualSchedule/InvestorAccrualScheduleReport";
import IssuerAccrualScheduleReportReport from "../Reports/AccrualSchedule/IssuerAccrualScheduleReport";
import DividendLetterReport from "../Reports/DividendLetter/DividendLetterReport";
import InvestorDividendReport from "../Reports/Dividends/InvestorDividendReport";
import DwtReport from "../Reports/DwtReport/DwtReport";
import ExampleReport from "../Reports/Example/ExampleReport";
import PortfolioStatementReport from "../Reports/PortfolioStatement/PortfolioStatementReport";
import ShareAllocationListReport from "../Reports/ShareAllocationList/ShareAllocationListReport";
import IssuerDividendReport from "../Reports/Dividends/IssuerDividendReport"
import DividendPayableWriteUpReport from "../Reports/DividendPayableWriteUp/DividendPayableWriteUpReport";
import InterCompanyDividendLetterReport from "../Reports/InterCompanyDividendLetter/InterCompanyDividendLetterReport";
import SuperSetReport from "../Reports/SuperSet/SuperSetReport";
import AuditConfirmationReport from "../Reports/AuditConfirmation/AuditConfirmationReport";
import TaxConfirmationReport from "../Reports/TaxConfirmation/TaxConfirmationReport";
import IssuerDividendLetterReport from "../Reports/IssuerDividendLetter/IssuerDividendLetterReport";
import PowerPuffReport from "../Reports/PowerPuff/PowerPuffReport";
import LiquidityLadderReport from "../Reports/LiquidityLadder/LiquidityLadderReport";
import CustomInvestorInvestmentDetailReport from "../Reports/InvestorInvestment/CustomInvestorInvestmentDetailReport";
import RicosReport from "../Exports/Ricos/RicosExport";
import PRNReport from "../Exports/PRNExport/PRNExport";
import IFRSExposureReport from "../Exports/IFRSExposure/IFRSExposureExport";
import LiabilityWriteUpReport from "../Reports/Liability/LiabilityWriteUpReport";
import FundingReport from "../Reports/Funding/FundingReport";
import SingularInfoReport from "../Exports/SingularInfo/SingularInfoExport";
import LiabilityWriteUpFlexiReport from "../Reports/LiabilityWriteUpFlexi/LiabilityWriteUpFlexiReport";
import BankTransferLetterReport from "../Reports/BankTransferLetter/BankTransferLetterReport";
import WacofReport from "../Reports/Wacof/WacofReport";
import BankTransferLetterCapitalReport from "../Reports/BankTransferLetterCapital/BankTransferLetterCapitalReport";
import AlcoReport from "../Reports/Alco/AlcoReport";
import CededClientInvestmentReport from "../Reports/CededClientInvestment/CededClientInvestmentReport";
import DividendResolutionReport from "../Reports/DividendResolution/DividendResolutionReport";
import SpareCapacityReport from "../Reports/SpareCapacity/SpareCapacityReport";
import QPTrackingReport from "../Reports/QPTracking/QPTrackingReport";
import InvestmentRateChangeReport from "../Reports/RateChange/RateChangeRate";
import UnauthorisedInvestmentReport from "../Reports/Unauthorised/UnauthorisedInvestmentReport";
import ExposureReport from "../Reports/Exposure/ExposureReport";
import ShareCapitalReport from "../Reports/ShareCapital/ShareCapitalReport";
import UnauthorisedCounterpartyReport from "../Reports/Unauthorised/UnauthorisedCounterpartyReport";
import AgeAnalysisLiabilityReport from "../Reports/AgeAnalysisLiability/AgeAnalysisLiabilityReport";
import AuditTrailInvestmentReport from "../Reports/AuditTrail/AuditTrailinvestmentReport";
import CustomIssuerInvestmentReport from "../Reports/IssuerInvestment/CustomIssuerInvestmentReport";
import AuditTrailUserReport from "../Reports/Audit/AuditTrailUserReport";
import AuditTrailReport from "../Reports/AuditTrail/AuditTrailReport";
import FlexiDivAnnexureReport from "../Reports/FlexiDivAnnexure/FlexiDivAnnexureReport";
import AssetProjectionReport from "../Reports/AssetProjection/AssetProjectionReport";
import AuditTrailRemindersReport from "../Reports/AuditTrailReminders/AuditTrailRemindersReport";
import IssuerPaymentScheduleReport from "../Reports/IssuerPaymentSchedule/IssuerPaymentScheduleReport";
import IssuerInvestmentAccrualScheduleReport from "../Reports/AccrualSchedule/IssuerInvestmentAccrualScheduleReport";

@injectable()
@NeoModel
export default class ReportingService extends ReportingServiceBase {

    protected getReports() {
        const config = AppService.get(Types.App.Config);

        const reportList = [
            InvestorAccrualReport,
            InvestorDividendReport,
            IssuerAccrualReport,
            ShareAllocationListReport,
            // TradeReport, // Report not ready yet
            DividendLetterReport,
            IssuerDividendLetterReport,
            InterCompanyDividendLetterReport,
            DwtReport,
            PortfolioStatementReport,
            IssuerDividendReport,
            InvestorAccrualScheduleReportReport,
            IssuerAccrualScheduleReportReport,
            IssuerInvestmentAccrualScheduleReport,
            DividendPayableWriteUpReport,
            LiquidityLadderReport,
            SuperSetReport,
            PowerPuffReport,
            AuditConfirmationReport,
            TaxConfirmationReport,
            CustomInvestorInvestmentDetailReport,
            RicosReport,
            PRNReport,
            IFRSExposureReport,
            LiabilityWriteUpReport,
            LiabilityWriteUpFlexiReport,
            FlexiDivAnnexureReport,
            FundingReport,
            SingularInfoReport,
            BankTransferLetterReport,
            BankTransferLetterCapitalReport,
            WacofReport,
            AlcoReport,
            CededClientInvestmentReport,
            DividendResolutionReport,
            SpareCapacityReport,
            QPTrackingReport,
            InvestmentRateChangeReport,
            UnauthorisedInvestmentReport,
            ExposureReport,
            ShareCapitalReport,
            UnauthorisedCounterpartyReport,
            AgeAnalysisLiabilityReport,
            AuditTrailInvestmentReport,
            CustomIssuerInvestmentReport,
            AuditTrailUserReport,
            AuditTrailReport,
            AssetProjectionReport,
            AuditTrailRemindersReport,
            IssuerPaymentScheduleReport

        ] as (new () => IReport)[];

        if (config.isDevelopment) {
            reportList.push(ExampleReport);
        }

        return reportList;
    }
}